module.exports = __webpack_public_path__ + "img/svg/paypal.82acf2b55a579e040929e6cad573c8fc.svg";